export const ADD_BATCH: string = "ADD_BATCH";
export const CLEAR_BATCHES: string = "CLEAR_BATCHES";

export function addBatch(name: string, contactsNo:number,scheduleTime:string, status:number): IAddBatchActionType {
    return { type: ADD_BATCH, name:name, contactsNo:contactsNo, scheduleTime:scheduleTime, status:status}
}
export function clearBatches(): IClearBatchActionType {
    return { type: CLEAR_BATCHES};
}

interface IAddBatchActionType { 
    type:string,
    name: string, 
    contactsNo:number,
    scheduleTime:string, 
    status:number
}

interface IClearBatchActionType { 
    type:string 
}